import React from 'react';
const Affix = ({ dataHook, children, size, className }) => {
    return children
        ? React.cloneElement(children, {
            size: size === 'medium' ? 24 : 18,
            className,
            'data-hook': dataHook,
        })
        : null;
};
export { Affix };
//# sourceMappingURL=Affix.js.map